'use strict'

import Swiper from '../../components/swiper'

export default class RegionalPresence
{
  constructor()
  {
    this.$elem = $('.RegionalPresence')

    if( this.$elem.length > 0 ){
      let self = this

      $(document).ready(function(){
        self._companies()
        self.$slideGallery = {}
        self._gallery()
      })
    }
  }

  _companies(){
    let self = this
    let $layout = $('.RegionalPresence__companies')
    let $sidebar = $('.Page .Sidebar')

    let resizerBox = () => {
      if( window.innerWidth >= 1200 ){
        if( $layout.hasClass('-full') ){
          $layout.removeClass('-full')
        }
        
        let valueWidth = 0
        if( !$sidebar.hasClass('show_complete') ){
          valueWidth = window.innerWidth - 70
        } else{
          valueWidth = window.innerWidth - $sidebar.outerWidth()
        }

        $layout.css({
          'max-width' : valueWidth
        })
          
      } else{
        if( !$layout.hasClass('-full') ){
          $layout.addClass('-full', 300, 'swing')
        }
      }
    }
    resizerBox()

    let $gallery = self.$elem.find('.RegionalPresence__gallery')
    let $gallery_container = $gallery.find('.RegionalPresence__gallery__container')
    let $tabs = $layout.find('.RegionalPresence__companies__tabs')
    let $content = $layout.find('.RegionalPresence__companies__content')
    let $loader = $gallery.find('.loader_theme')

    let getDataAJAX = ( id ) => {
      $.ajax({
        method: "POST",
        url : ajaxurl,
        data: { action: "obtener_galeria_empresas", id: id}
      }).done(function( response ) {
        $gallery_container.find('.swiper-wrapper').append(response)
        $gallery_container.find('.swiper-wrapper .swiper-slide').hide()

        $loader.removeClass('show_custom')
        $.each($gallery_container.find('.swiper-wrapper .swiper-slide'), function( i,val ){
          $(this).show('fade', 300)
        })

        self.$slideGallery.update()
      })
    }

    $tabs.on('click', '.item_tab', function( event ){
      event.preventDefault();
      event.stopPropagation();

      $(this).addClass('active').siblings().removeClass('active');

      var id = $(this).attr('data-id');
      var title = $(this).attr('data-title');
      var newContent = $(this).attr('data-content');

      $gallery.find('.gallery_title h2').text(title);
      $('#tittle_gal').text(title);
      $content.children('p').html(newContent);

      $gallery_container.find('.swiper-wrapper .swiper-slide').hide('drop', 300, function () {
        $gallery_container.find('.swiper-wrapper .swiper-slide').remove();
      });

      $loader.addClass('show_custom', 300, 'swing', function () {
        getDataAJAX(id);
      });
    })
  }

  _gallery(){
    let self = this
    let $layout = $('.RegionalPresence__gallery')
    let $sidebar = $('.Page .Sidebar')

    let resizerBox = () => {
        if( window.innerWidth >= 1200 ){
            if( $layout.hasClass('-full') ){
                $layout.removeClass('-full')
            }
            
            let valueWidth = 0
            if( !$sidebar.hasClass('show_complete') ){
                valueWidth = window.innerWidth - 70
            } else{
                valueWidth = window.innerWidth - $sidebar.outerWidth()
            }

            $layout.css({
                'max-width' : valueWidth
            })
            
        } else{
            if( !$layout.hasClass('-full') ){
                $layout.addClass('-full', 300, 'swing')
            }
        }
    }
    resizerBox()
    
    let slideToShow = window.innerWidth >= 768 ? 'auto' : 1

    self.$slideGallery = new Swiper( '.RegionalPresence__gallery__container', {
      slidesPerView: slideToShow,
      prevButton: '.gallery_container .buttons_controls.prev',
      nextButton: '.gallery_container .buttons_controls.next',
      mousewheelControl: true
    })

    $(window).resize( ()=> {
      resizerBox()
    })

    $(window).on("orientationchange", ()=> {
      resizerBox()
    })
  }
}

